module.exports = __webpack_public_path__ + "static/media/sg11tj93.1aa2f497.png";